export const CATEGORY_SUCCESS = "CATEGORY_SUCCESS";
export const CATEGORY_LOADING = "CATEGORY_LOADING";
